const DeviceStorage = require('src/components/DeviceStorage/DeviceStorage').default;

const DEBUG = 0;
const INFO = 1;
const WARN = 2;
const ERROR = 3;
const MIN_LEVEL = process.env.NODE_ENV === 'production' ? WARN : DEBUG;

let handlersRegistered = false;
let storageContext;
const STORAGE_CONTEXT_KEYS = ['region', 'appVersion', 'user_id'];

function invalidateStorageContext(key) {
  if (typeof key === 'undefined' || STORAGE_CONTEXT_KEYS.indexOf(key) !== -1) {
    storageContext = null;
  }
}

if (typeof DeviceStorage.subscribeToChanges === 'function') {
  DeviceStorage.subscribeToChanges(invalidateStorageContext);
}

function serializePart(value) {
  if (value instanceof Error) {
    return value.message;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (value === null || typeof value === 'undefined') {
    return '';
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (error) {
      return '[unserializable-object]';
    }
  }

  return String(value);
}

function getContext() {
  if (!storageContext) {
    storageContext = {
      region: DeviceStorage.getItem('region') || '',
      appVersion: DeviceStorage.getItem('appVersion') || '',
      user_id: DeviceStorage.getItem('user_id') || '',
    };
  }

  const url = typeof window !== 'undefined' && window.location && window.location.href
    ? window.location.href
    : '';

  return {
    ...storageContext,
    url,
  };
}

function emit(entry) {
  if (typeof console !== 'undefined' && typeof console.debug === 'function') {
    console.debug(JSON.stringify(entry));
  }
}

function log(levelValue, levelName, args, error) {
  if (levelValue < MIN_LEVEL) {
    return;
  }

  const entry = {
    timestamp: new Date().getTime(),
    level: levelName,
    message: args.map(serializePart).filter(Boolean).join(' '),
    ...getContext(),
  };

  if (error && error.stack) {
    entry.stack = error.stack;
  }

  emit(entry);
}

function getErrorFromArguments(args) {
  for (let index = 0; index < args.length; index += 1) {
    if (args[index] instanceof Error) {
      return args[index];
    }
  }

  return null;
}

const logger = {
  debug() {
    log(DEBUG, 'debug', Array.prototype.slice.call(arguments));
  },

  info() {
    log(INFO, 'info', Array.prototype.slice.call(arguments));
  },

  warn() {
    log(WARN, 'warn', Array.prototype.slice.call(arguments));
  },

  error(message, err) {
    const args = Array.prototype.slice.call(arguments);
    const error = err instanceof Error ? err : getErrorFromArguments(args);
    const messageParts = [];

    if (typeof message !== 'undefined') {
      messageParts.push(message);
    }

    args.slice(1).forEach((part) => {
      if (!(part instanceof Error)) {
        messageParts.push(part);
      }
    });

    log(ERROR, 'error', messageParts, error);
  },

  invalidateContext() {
    invalidateStorageContext();
  },

  registerGlobalHandlers() {
    if (handlersRegistered || typeof window === 'undefined') {
      return;
    }

    handlersRegistered = true;

    window.onerror = (message, source, lineno, colno, error) => {
      logger.error(serializePart(message), error || new Error(serializePart(message)));
      return false;
    };

    window.addEventListener('unhandledrejection', (event) => {
      const reason = event && event.reason ? event.reason : 'Unhandled promise rejection';
      const rejectionError = reason instanceof Error ? reason : new Error(serializePart(reason));
      logger.error(serializePart(reason), rejectionError);
    });
  },
};

module.exports = logger;



// WEBPACK FOOTER //
// ./src/utils/logger/logger.js